import type { Product } from 'src/types';
import type { ClientMarket } from '@prisjakt/web-app-config/types/client-market';
import type { Offer } from 'schema-dts';
import { getRoundedCurrency } from './utils';

export function offer(product: Product, market: ClientMarket): Offer {
  return {
    '@type': 'Offer',
    url: market.domain + product.pathName,
    price: getRoundedCurrency(product.priceSummary.regular!, market),
    priceCurrency: market.currency,
  };
}
